import { createStyles, makeStyles } from '@material-ui/core'

export default makeStyles((theme) =>
  createStyles({
    mr2: { marginRight: theme.spacing(1) },
  })
)
